

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.CMRU4NuT.js","_app/immutable/chunks/stores.vbHk8Adl.js","_app/immutable/chunks/client.B96STMEW.js"];
export const stylesheets = [];
export const fonts = [];
